import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ResidentAbsDataTable {
  constructor() {
    $(document).ready(function() {
      showResidentAbsTable();
    });

    $(document).on("turbo:render", function() {
      showResidentAbsTable();
    });

    function showResidentAbsTable() {
      $('#resident-abs-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#resident-abs-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
